import styled from 'styled-components';

export const ReturnBackground = styled.div`
  background-color: ${({ theme }) => theme.color.shadow_10};
  margin-left: -20px;
  padding: 30px 15px 0 15px;
`;
